/**
 * Statistics service
 * Handles dashboard statistics queries
 */

import { collection, getDocs, query, where } from 'firebase/firestore';
import { db } from '../config/firebase';

export interface DashboardStats {
  totalCompanies: number;
  totalUsers: number;
  activeOneTimeJobs: number;
}

/**
 * Load dashboard statistics
 * Optimized with proper Firestore queries instead of load-all-filter pattern
 */
export const getDashboardStats = async (): Promise<DashboardStats> => {
  try {
    // Run all queries in parallel for better performance
    const [companiesSnapshot, companyUsersSnapshot, managerUsersSnapshot, staffUsersSnapshot, activeJobsSnapshot, scheduledJobsSnapshot] = await Promise.all([
      // Count companies
      getDocs(collection(db, 'Companies')),

      // Count customer users with proper where clauses (exclude super_admin)
      getDocs(query(collection(db, 'Users'), where('userType', '==', 'company'))),
      getDocs(query(collection(db, 'Users'), where('userType', '==', 'manager'))),
      getDocs(query(collection(db, 'Users'), where('userType', '==', 'staff'))),

      // Count active and scheduled one-time jobs separately with where clauses
      getDocs(query(collection(db, 'OneTimeJobs'), where('status', '==', 'active'))),
      getDocs(query(collection(db, 'OneTimeJobs'), where('status', '==', 'scheduled'))),
    ]);

    const totalCompanies = companiesSnapshot.size;
    const totalUsers = companyUsersSnapshot.size + managerUsersSnapshot.size + staffUsersSnapshot.size;
    const activeOneTimeJobs = activeJobsSnapshot.size + scheduledJobsSnapshot.size;

    return {
      totalCompanies,
      totalUsers,
      activeOneTimeJobs,
    };
  } catch (error) {
    console.error('Error loading dashboard stats:', error);
    throw error; // Throw error instead of silently returning zeros
  }
};
